import * as angular from 'angular';

import { ComponentDefinition, Log } from '../../../../models';

class PaginatedLogsListController implements angular.IComponentController {
    currentPage = 0;
    pageSize = 50;
    pagedArray: Log[][];
    pagedLogs: Log[];

    readonly logs: Log[];

    static $inject = [];

    $onChanges(changesObj: angular.IOnChangesObject) {
        if (changesObj['logs']?.currentValue) {
            this.currentPage = 0;
            this.pagedArray = this.paginate(this.logs, this.pageSize);
            this.pagedLogs = this.pagedArray[0];
        }
    }
    
    selectPage($index: number) {
        this.currentPage = $index;
        this.pagedLogs = this.pagedArray[this.currentPage];
    }

    paginate(logs: Log[], pageSize: number): Log[][] {
        const result: Log[][] = [];
        for (let index = 0; index < logs.length; index += pageSize) {
            const myChunk = logs.slice(index, index + pageSize);
            // Do something if you want with the group
            result.push(myChunk);
        }
        return result;
    }
}

export const wtPaginatedLogsList: ComponentDefinition = {
    componentId: 'wtPaginatedLogsList',
    controller: PaginatedLogsListController,
    template: require('./paginatedLogsList.component.html'),
    controllerAs: 'vm',
    bindings: {
        logs: '<'
    }
};
